module.exports = __webpack_public_path__ + "static/media/Roboto Mono.b4618f1f.ttf";